export default function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-format/src/formatNumerals.js
// module id = ../../../../d3-format/src/formatNumerals.js
// module chunks = 4